// extracted by mini-css-extract-plugin
export var filterIncDec = "_f6-0";
export var leftBorder = "_f6-1";
export var rightBorder = "_f6-2";
export var stringInput = "_f6-3";